export const parseStringDate = (date: string) => {
  const tmpDate = date.indexOf("T") ? date.split("T")[0] : date
  const [year, month, day] = tmpDate.split("-")
  return `${day}.${month}.${year}`
}
